import $ from 'jquery';
import {corpLifeNews} from '../api/api';
import _ from 'underscore';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-corporate-life',
			dom: {
				showMore: '.js-show-more',
				container: '.js-news-conteiner'
			},
			classes: {

			}
		};

		this.options = $.extend(true, {}, defaults, options);

		this.$el = $(this.options.el);
	}

	getDom() {
		const mustacheStyleSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};

		this.$showMore = this.$el.find(this.options.dom.showMore);
		const $tmpl = $('#newsTmpl').clone();
		$('#newsTmpl').remove();

		this.$newsTmpl = _.template(_.unescape($tmpl.html().trim()), mustacheStyleSyntax);
		this.$container = this.$el.find(this.options.dom.container);


		this.$el.find(this.options.dom.journalTmp).remove();
		return this;
	}

	showMore() {
		const data = {
			offset: this.$container.children().length,
			limit: this.step
		};

		corpLifeNews(data).then(resp => this.renderNews(resp));

	}

	renderNews(data) {console.log(data);
		data.items.forEach(item => {
			this.$container.append(this.$newsTmpl({data: item}));
		});

		if (this.$container.children().length >= data.count) {
			this.$showMore.hide();
		}
	}


	render() {
		if (this.$el.length) {
			this.getDom();
			this.$showMore.on('click', e => this.showMore(e));
			this.step = Number(this.$container.attr('data-step'));

		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/corporate-life/corporate-life.js
 **/